import { routeHistory } from '@nackle/biw-web-router';
import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { authService } from '../../../services';
import { PageContainer, PageContent } from '../../common';
import './styles.less';

export const Goodbye = () => {

    useEffect( () => {
        setTimeout( () => {if ( authService.isAuthenticated() ) {routeHistory.push( '/' );}}, 3000 );
    }, [] );

    return (
        <PageContent className="page-goodbye">
            <PageContainer>

                <Spin />
            </PageContainer>
        </PageContent>
    );
    
};